import {Component, OnInit, Injector} from '@angular/core';
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-form-year',
    templateUrl: 'efast-filter-form-year.component.html',
    styleUrls: ['efast-filter-form-year.component.css'],
    standalone: false
})

export class EfastFilterFormYearComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERFormYearTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().FORM_YEARS

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl1'),
            this.staticsService.getFormYearFilter().YEAR_1));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl2'),
            this.staticsService.getFormYearFilter().YEAR_2));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl3'),
            this.staticsService.getFormYearFilter().YEAR_3));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl4'),
            this.staticsService.getFormYearFilter().YEAR_4));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl5'),
            this.staticsService.getFormYearFilter().YEAR_5));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl6'),
            this.staticsService.getFormYearFilter().YEAR_6));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl7'),
            this.staticsService.getFormYearFilter().YEAR_7));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl8'),
            this.staticsService.getFormYearFilter().YEAR_8));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl9'),
            this.staticsService.getFormYearFilter().YEAR_9));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl10'),
            this.staticsService.getFormYearFilter().YEAR_10));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl11'),
            this.staticsService.getFormYearFilter().YEAR_11));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl12'),
            this.staticsService.getFormYearFilter().YEAR_12));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl13'),
            this.staticsService.getFormYearFilter().YEAR_13));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl14'),
            this.staticsService.getFormYearFilter().YEAR_14));
        filterValues.push(this.addFilterValue(
                this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl15'),
                this.staticsService.getFormYearFilter().YEAR_15));
        filterValues.push(this.addFilterValue(
                this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl16'),
                this.staticsService.getFormYearFilter().YEAR_16));
        filterValues.push(this.addFilterValue(
                this.cacheService.getLabelFromResource('FILTER:FILTERFormYearLbl17'),
                this.staticsService.getFormYearFilter().YEAR_17));
        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }
    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.formyear.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {
        super.rowClick(filterValue);
        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().FORM_YEAR, this.queryValue, true)
    }

}